import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm, stopAsyncValidation } from 'redux-form/immutable'
import { connect } from 'react-redux'

import { addReducer, removeReducer } from 'state/reducers'
import { addSaga, removeSaga } from 'state/sagas'

import Page from 'layouts/Page'
import Masthead, { MastheadOverlap } from 'layouts/Masthead'
import Container from 'layouts/Container'
import { FormFieldset } from 'layouts/Form'
import Box, { BoxSection } from 'layouts/Box'
import Input from 'components/Input'
import Button from 'components/Button'
import Switch from 'components/Switch'
import Link from 'components/Link'
import { Node, md } from 'djedi-react'

import { NAME as ROUTE_LOGIN } from 'views/Login/constants'
import { reverse } from 'utilities/routes'
import { required } from 'utilities/validators'

import { NAME, PARENT_SIGNUP, LEADER_SIGNUP } from './constants'
import reducer from './reducer'
import actions from './actions'
import saga from './sagas'
import selector from './selectors'

import styles from './styles.css'

class SignupPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    asyncValidating: PropTypes.bool.isRequired,
    signupType: PropTypes.oneOf([PARENT_SIGNUP, LEADER_SIGNUP]),
    success: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    signupType: PARENT_SIGNUP,
  }

  componentDidMount() {
    addReducer(NAME, reducer)
    addSaga(NAME, saga)
  }

  componentWillUnmount() {
    removeReducer(NAME)
    removeSaga(NAME)
  }

  onSubmit = values => this.props.dispatch(actions.submit(values.toJS()))

  render() {
    const { success, asyncValidating, signupType } = this.props
    const isLeaderSignup = signupType === LEADER_SIGNUP
    if (success) {
      return (
        <Page className={styles.root} title="Nästan klar">
          <Masthead>
            <Container size="medium">
              <h1>Nästan klar!</h1>
              <p>
                Ett veriferingsmejl har skickats till din mejladress. Följ
                instruktionerna i mejlet för att slutföra din registrering.
              </p>
            </Container>
          </Masthead>
        </Page>
      )
    }
    const termsLabel = isLeaderSignup ? (
      <React.Fragment>
        Jag godkänner{' '}
        <Link href={reverse('static/villkor-for-ansokan')} target="_blank">
          villkor för ansökan
        </Link>
      </React.Fragment>
    ) : (
      <React.Fragment>
        Jag godkänner{' '}
        <Link href={reverse('static/allmanna-villkor')} target="_blank">
          allmänna villkor
        </Link>
      </React.Fragment>
    )
    return (
      <Page
        className={styles.root}
        title={isLeaderSignup ? 'Bli ledare' : 'Skapa konto'}
      >
        <Masthead overlap>
          <Container size="medium">
            {isLeaderSignup ? (
              <Node uri="signup/text1.md">
                {md`
                  #Bli ledare

                  Vi erbjuder dig ett flexibelt och meningsfullt
                  extrajobb där du tjänar från 130 kr/tim upp
                  till 200 kr/tim, genom att jobba med ditt
                  intresse som kan vara teater, musik, bakning,
                  språk, programmering eSport eller något helt,
                  helt annat.
                `}
              </Node>
            ) : (
              // TODO: djedi-react should support embedding JSX elements in nodes.
              <React.Fragment>
                <h1>Skapa konto</h1>
                <p>
                  Här skapar du konto som förälder. Om du vill bli ledare, gå in
                  på <Link href={reverse(LEADER_SIGNUP)}>Bli Ledare</Link>.
                </p>
              </React.Fragment>
            )}
          </Container>
        </Masthead>

        <MastheadOverlap>
          <Container size="medium">
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
              <Box shadow>
                {isLeaderSignup && (
                  <BoxSection className={styles.marginTop}>
                    <Node uri="signup/text2.md">
                      {md`
                        #####Om rollen som ledare

                        Du leder en aktivitet kring ditt
                        intresse och blir en viktig förebild
                        för skolbarnen i din lilla grupp om max
                        fyra barn.

                        Du bestämmer själv var och när du vill
                        jobba och ju mer du jobbar och ju fler
                        duktiga vänner du rekryterar som
                        ledare, desto mer tjänar du. Låter det
                        bra? Ansök idag genom att skapa ett
                        konto och registrera din profil.
                      `}
                    </Node>
                  </BoxSection>
                )}
                <BoxSection>
                  <FormFieldset>
                    <Field
                      component={Input}
                      label="Din e-postadress"
                      type="email"
                      name="email"
                      validate={[required]}
                    />

                    <Field
                      component={Input}
                      label="Ange lösenord"
                      type="password"
                      name="password"
                      validate={[required]}
                    />

                    <div>
                      <Field
                        component={Switch}
                        type="checkbox"
                        label={termsLabel}
                        validate={[required]}
                        name="gdpr"
                      />
                    </div>

                    <div>
                      <Field
                        component={Switch}
                        type="checkbox"
                        label="Jag godkänner kommunikation från friendtivity"
                        validate={[required]}
                        name="communication"
                      />
                    </div>
                  </FormFieldset>

                  <div style={{ textAlign: 'center' }}>
                    <Button loading={asyncValidating} rounded>
                      Skapa konto
                    </Button>

                    <p>
                      Redan registrerad?{' '}
                      <Link href={reverse(ROUTE_LOGIN)}>Logga in</Link>.
                    </p>
                  </div>
                </BoxSection>
              </Box>
            </form>
          </Container>
        </MastheadOverlap>
      </Page>
    )
  }
}

export default connect(selector)(
  reduxForm({
    form: NAME,
    onChange: (values, dispatch) => {
      dispatch(stopAsyncValidation(NAME, { clear: true }))
    },
  })(SignupPage),
)



// WEBPACK FOOTER //
// ../source/views/Signup/index.js